import { DecimalJsUtil } from '@shared/utils/decimal-js-util';

export class ItemPrice<T> {
  private readonly item: T;
  private readonly qty: number;

  constructor(item: T, qtyField: string) {
    this.item = item;
    this.qty = this.item[qtyField];
  }

  getTotalFrom(field: string) {
    return getPriceFormat(DecimalJsUtil.multiply(this.item[field].amount, this.qty), this.item[field].currency);
  }
}

export const getPriceFormat = (amount = 0, currency = 'THB') => {
  return {
    amount,
    currency
  };
};
